import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SlippersIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SlippersIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M6.54712 3.30682C4.18066 3.30682 2.25488 5.23213 2.25488 7.59906V16.9408C2.25488 19.3077 4.18067 21.233 6.54712 21.233C8.91357 21.233 10.8394 19.3077 10.8394 16.9408V7.59906C10.8394 5.23213 8.91357 3.30682 6.54712 3.30682ZM3.20871 10.4606C3.20871 8.78229 4.45489 7.39304 6.0702 7.1603V10.2631L3.20871 13.1246V10.4606ZM9.88553 16.9408C9.88553 18.7812 8.38801 20.2792 6.54712 20.2792C4.70623 20.2792 3.20871 18.7812 3.20871 16.9408V14.4733L6.54712 11.1349L9.88553 14.4733V16.9408ZM9.88553 13.1246L7.02404 10.2631V7.16032C8.63935 7.39305 9.88553 8.78231 9.88553 10.4606V13.1246ZM9.88553 7.76886C9.09814 6.79404 7.89488 6.16833 6.54712 6.16833C5.19936 6.16833 3.9961 6.79404 3.20871 7.76886V7.59908C3.20871 5.75866 4.70623 4.26067 6.54712 4.26067C8.38801 4.26067 9.88553 5.75866 9.88553 7.59908V7.76886Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9929 3.30682C15.6265 3.30682 13.7007 5.23213 13.7007 7.59906V16.9408C13.7007 19.3077 15.6265 21.233 17.9929 21.233C20.3594 21.233 22.2852 19.3077 22.2852 16.9408V7.59906C22.2852 5.23213 20.3594 3.30682 17.9929 3.30682ZM14.6545 10.4606C14.6545 8.78229 15.9007 7.39304 17.516 7.1603V10.2631L14.6545 13.1246V10.4606ZM21.3313 16.9408C21.3313 18.7812 19.8338 20.2792 17.9929 20.2792C16.152 20.2792 14.6545 18.7812 14.6545 16.9408V14.4733L17.9929 11.1349L21.3313 14.4733V16.9408ZM21.3313 13.1246L18.4698 10.2631V7.16032C20.0852 7.39305 21.3313 8.78231 21.3313 10.4606V13.1246ZM21.3313 7.76886C20.5439 6.79404 19.3407 6.16833 17.9929 6.16833C16.6452 6.16833 15.4419 6.79404 14.6545 7.76886V7.59908C14.6545 5.75866 16.152 4.26067 17.9929 4.26067C19.8338 4.26067 21.3313 5.75866 21.3313 7.59908V7.76886Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SlippersIcon;
